<template>
  <div>
    <img
      style="width: 100vw;"
      src="../../assets/h5/news.png"
    />
  </div>
</template>

<script>
export default {}
</script>

<style scoped></style>
